import { Injectable } from '@angular/core';

import { MagnetService } from '@mirage-projects/cw-commons';

/**
 * Verity only supports embed mode, if differs, redirection to verity external url
 */
@Injectable({
    providedIn: 'root',
})
export class VerityGuard {
    constructor(private magnetService: MagnetService) {}

    canActivate(): boolean {
        if (this.magnetService.isVerity()) {
            window.location.href = this.magnetService.getVerityRedirection();
            return false;
        }
        return true;
    }
}
